module.exports = __webpack_public_path__ + "img/desc_bottom_vtyhv1.c8d362cd.png";